import React, {
  ReactElement, useEffect, useRef, useState,
} from 'react';
import { useParams, useHistory, generatePath } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import {
  Radio, Button, Card,
} from 'antd';
import { useForm } from 'react-hook-form';
import { injectIntl } from 'react-intl';
import moment from 'moment';
import { faPrint } from '@fortawesome/pro-light-svg-icons';
import { useBreakpoint } from '../../../../hooks/useBreakpoint';
import Tests from '../../components/eyeChart/tests';
import HistorialOptometric from '../../components/eyeChart/historial';
import { ROUTE_PACIENTES_EYECHART_EDIT, ROUTE_PACIENTES_FILE } from '../../../../routes.constants';
import EyeChartContent from '../../components/eyeChart/eyeChartContent';
import {
  getGraduacion, getGraduacionExtendida, getOldGraduacion, getPrescriptores, getUsuarios, setGraduacion,
} from '../../../../state/actions/creators/fichaOptometrica.actioncreator';
import { requiredRuleEjeCilindro, requiredRuleEyeChart } from '../../components/newPatient/rules';
import UsuariosDrawer from '../../../app/components/Usuarios.drawer';
import {
  ShowIf,
  Text,
} from '../../../shared/components';
import { getPaciente } from '../../../../state/actions/creators/pacientes.actioncreator';
import Page from '../../../shared/components/layout/Page.layout';
import LoadingWorkspaceSkeleton from '../../../encargos/components/dataDisplay/LoadingWorkspaceSkeleton.datadisplay';
import ActionsHeader, { NAVIGATION_ANCHOR } from '../../../shared/containers/ActionsHeader';
import CancelModal from '../../../shared/components/dataDisplay/CancelModal';
import { descargarInforme } from '../../../../state/actions/creators/informes.actioncreator';
import { MIN_WIDTH } from '../../../../state/actions/constants/app.constants';
import { useScrollToError } from '../../../../hooks/useScrollToError';

interface eyeChartProps{
  intl: any,
  create: boolean,
  watch: boolean,
}

interface contentTable {
  [key: string]: ReactElement;
}

function EyeChart({ intl, create = true, watch = false }:eyeChartProps) {
  const history = useHistory();
  const [simplified, setSimplified] = useState(true);
  const [tabState, setTabState] = useState('pruebas');
  const breakPoint = useBreakpoint();
  const [drawerAttended, setDrawerAttended] = useState(false);
  const [drawerPrescriber, setDrawerPrescriber] = useState(false);
  const id_atendido_por = useSelector((state: any) => state.auth.user.user_info.usuario_id);
  const atendido_por = useSelector((state: any) => state.auth.user.user_info.usuario);
  const [attendedStr, setAttendedStr] = useState(create ? atendido_por : '');
  const [doScrollNextRender, setDoScroll] = useState(false);

  const [prescriberStr, setPrescriberStr] = useState('');
  const [cancelModalState, setCancelModalState] = useState(false);

  const ref = useRef(null);
  const sagas = useSelector((state: any) => state.sagas);
  const appNavigation = useSelector((state: any) => state.app.navigation);
  const pacienteSelected = useSelector((state: any) => state.pacientesWorkspace.pacienteSelected);
  const usuarios = useSelector((state: any) => state.fichaOptometricaWorkspace.usuarios);
  const totalUsuarios = useSelector((state: any) => state.fichaOptometricaWorkspace.totalUsuarios);
  const totalPrescriptores = useSelector((state: any) => state.fichaOptometricaWorkspace.totalPrescriptores);
  const prescriptores = useSelector((state: any) => state.fichaOptometricaWorkspace.prescriptores);
  const configuraciones = useSelector((state: any) => state.auth.permisos.configuracion);
  const dispatch = useDispatch();
  const { pacienteId, codigo, tiendaGraduacion }: any = useParams();
  const cancelPath = generatePath(ROUTE_PACIENTES_FILE, { pacienteId });
  const diasHastaProximaGraduacion = configuraciones?.prox_gradopt ? configuraciones.prox_gradopt : 365;
  const guardandoOptometria = sagas?.PACIENTES_CREATE_FICHA_OPTOMETRICA?.running || sagas?.PACIENTES_UPDATE_FICHA_OPTOMETRICA?.running || sagas?.SET_GRADUACION?.running;
  
  const optometriaSagaLoading = sagas?.GET_GRADUACION?.running;
  const hookForms = useForm({
    mode: 'all',
    shouldUnregister: false,
    defaultValues: {
      tipo_ficha: 'simple',
      codigo: '',
      tienda: '',
      fecha: create ? moment() : null,
      fecha_proxima_graduacion: create ? moment().add(diasHastaProximaGraduacion, 'days') : null,
      atendido_por_id: create ? id_atendido_por : '',
      prescriptor_id: '',
      rx_inicial: {},
      prescripcion: {
        ojo_derecho: {
          eje: '',
          cilindro: '',
        },
        ojo_izquierdo: {
          eje: '',
          cilindro: '',
        },
      },
      distancias: {},
      observaciones: '',
      info_extendida: [],
      pios: [],
      otros_datos: {
        ojo_derecho: {
          prisma: '',
          queratometria: '',
          cilindro_corneal: '',
        },
        ojo_izquierdo: {
          prisma: '',
          queratometria: '',
          cilindro_corneal: '',
        },
      },
      refractometro: {
        ojo_derecho: {
          eje: '',
          cilindro: '',
          esfera: '',
        },
        ojo_izquierdo: {
          eje: '',
          cilindro: '',
          esfera: '',
        },
      },
      observacion_pupilas: '',
      motilidad_ocular: '',
      ppc: '',
      rx_antigua: {},
      agudeza_visual: {},
      cover_test: {
        cerca: {
          sin_correccion: '',
          con_correccion: '',
        },
        lejos: {
          sin_correccion: '',
          con_correccion: '',
        },
      },
      retinoscopia: {
        ojo_derecho: {
          eje: '',
          cilindro: '',
          esfera_lejos: '',
        },
        ojo_izquierdo: {
          eje: '',
          cilindro: '',
          esfera_lejos: '',
        },
      },
      subjetivo: {
        ojo_derecho: {
          esfera_cerca: '',
          esfera_lejos: '',
          eje: '',
          cilindro: '',
          adicion: '',
          AVVC: '',
        },
        ojo_izquierdo: {
          esfera_cerca: '',
          esfera_lejos: '',
          eje: '',
          cilindro: '',
          adicion: '',
          AVVC: '',
        },
      },
      binocularidad: {
        lejos_CRN: '',
        cerca_CRN: '',
        lejos_CRP: '',
        cerca_CRP: '',
      },
      binocularidad_prisma_lejos_cerca: {},
      prism_lejosycerca: {},
      impresion: '',
      motivo: '',
      tipo_lente: '',
      historial: {},
      transposicion: false,
      acomodacion: {
        mem: '',
      },
    },
  });
  const tiendaId = useSelector((state: any) => state.auth.user.user_info.tienda_id);
  const tienda_graduacion_id = useSelector((state:any) => state.fichaOptometricaWorkspace.graduacionSelected.tienda_id);
  const idGraduacionOptometrica = useSelector((state:any) => state.fichaOptometricaWorkspace.graduacionSelected.codigo);
  const historialOptometrica = useSelector((state:any) => state.fichaOptometricaWorkspace.graduacionSelected.historial);
  const {
    handleSubmit, setValue, getValues, register, errors, reset,
  } = hookForms;
  const doScroll = useScrollToError({ overwriteChangeDetection: true, errors });
  const cellRegister = ((elem: HTMLInputElement | HTMLTextAreaElement | null) => {
    if (watch && elem) elem.disabled = true;
    register(elem);
  });
  useEffect(() => {
    reset();
    if (!pacienteSelected) {
      dispatch(getPaciente({ tiendaId, pacienteId }));
    }
    if (!create) {
      if(idGraduacionOptometrica != codigo || tienda_graduacion_id != tiendaGraduacion) dispatch(getGraduacion(codigo, tiendaGraduacion))
      else dispatch(getOldGraduacion())
    }
    if (!prescriptores || prescriptores.length === 0) {
      dispatch(getPrescriptores(null));
    }
    if (!usuarios || usuarios.length === 0) {
      dispatch(getUsuarios(null));
    }
  }, []);

  useEffect(() => {
    if (!create && simplified === false) {
      if(historialOptometrica === null || historialOptometrica === undefined) dispatch(getGraduacionExtendida(codigo));
      else dispatch(getOldGraduacion())
    }
  }, [simplified]);

  useEffect(() => {
    if(doScrollNextRender){
      doScroll();
      setDoScroll(false);
    }
  }, [doScrollNextRender]);

  useEffect(() => {
    register({ name: 'tipo_ficha' });
    register('atendido_por_id', requiredRuleEyeChart(intl, 'user'));
    register('prescriptor_id', requiredRuleEyeChart(intl, 'prescriber'));
    register('historial');
    const pruebasKeys = ['otros_datos',
      'refractometro',
      'observacion_pupilas',
      'motilidad_ocular',
      'ppc',
      'rx_antigua',
      'cover_test',
      'retinoscopia',
      'binocularidad',
      'binocularidad_prisma_lejos_cerca',
      'subjetivo',
      'prism_lejosycerca',
      'motivo',
      'impresion',
      'tipo_lente',
      'pios'];
    pruebasKeys.forEach((key: string) => register(key));
  }, [register]);


  const handleChange = (name: any, value: any) => {
    setValue(name, value, { shouldValidate: true, shouldDirty: true });
    if (name === 'tipo_ficha') {
      setSimplified(!simplified);
    }
  };

  const onSubmit = (data: any) => {
    dispatch(setGraduacion({ pacienteId, codigo, data }));
  };

  const tabListNoTitle = [
    {
      key: 'pruebas',
      tab: `${intl.formatMessage({ id: 'pacientes.eye_chart.tests' })}`,
    },
    {
      key: 'historial',
      tab: `${intl.formatMessage({ id: 'pacientes.eye_chart.record' })}`,
    },
  ];

  const contentList: contentTable = {
    pruebas: <Tests create={create} watch={watch} hookForms={hookForms} />,
    historial: <HistorialOptometric create={create} watch={watch} hookForms={hookForms} />,
  };

  function onTabChange(key: any) {
    setTabState(key);
  }

  const onPrint = (informeId: number, plantillaId: number, parametros: any) => {
    dispatch(descargarInforme({ informeId, plantillaId, parametros }));
  };

  const headerData = [
    {
      translationId: 'pacientes.client_file.edit',
      text: 'Editar',
      onClick: () => history.push(generatePath(ROUTE_PACIENTES_EYECHART_EDIT, { pacienteId, codigo, tiendaGraduacion })),
    },
    {
      icon: faPrint,
      position: 'right',
      onClick: () => {},
      children: [
        {
          translationId: 'pacientes.activity.prescription',
          key: 'optometric_prescription',
          text: 'Receta',
          onClick: () => {
            onPrint(8, 38, { tienda_graduacion_id, graduacion_id: codigo, tienda_id: tiendaId });
          },
        },
        {
          translationId: 'pacientes.activity.history',
          key: 'optometric_prescriptions_history',
          text: 'Histórico',
          onClick: () => {
            onPrint(142, -1, { tienda_paciente_id: pacienteSelected.tienda_id, tienda_id: tiendaId, paciente_id: pacienteId });
          },
        },
        {
          translationId: 'pacientes.activity.complete_file',
          key: 'optometric_complete_file',
          text: 'Ficha completa',
          onClick: () => {
            onPrint(245, 11, { tienda_graduacion_id, graduacion_id: codigo, tienda_id: tiendaId });
          },
        },
      ],
    },
  ];
  let titleId = 'navigation.optometria';
  if (!watch) titleId = create ? 'pacientes.eye_chart.new_optometry' : 'pacientes.eye_chart.edit_optometry';
  let traduccionAccionFicha = 'pacientes.generic.titles.eye_chart';
  if (create) {
    traduccionAccionFicha = 'pacientes.eye_chart.new_optometry';
  } else if (!watch) {
    traduccionAccionFicha = 'pacientes.eye_chart.edit_optometry';
  }

  const eyeChart: ReactElement = (
    <>
      {watch && <ActionsHeader anchor={NAVIGATION_ANCHOR} sticky data={headerData} />
      }
      <form ref={ref}>
        <div className="formContainer">
          <div className="topBox_NP flexRow">
            <h2>{intl.formatMessage({ id: `${traduccionAccionFicha}` })}</h2>
            <Radio.Group
              onChange={(e: any) => handleChange('tipo_ficha', e.target.value)}
              defaultValue="simple"
              value={getValues('tipo_ficha')}
              size="large"
            >
              <Radio.Button value="simple">
                {intl.formatMessage({ id: 'pacientes.generic.params.simplified' })}
              </Radio.Button>
              <Radio.Button value="completa">
                {intl.formatMessage({ id: 'pacientes.generic.params.full' })}
              </Radio.Button>
            </Radio.Group>
          </div>
          <EyeChartContent
            create={create}
            watch={watch}
            hookForms={hookForms}
            setDrawerAttended={setDrawerAttended}
            setDrawerPrescriber={setDrawerPrescriber}
            attendedStr={attendedStr}
            prescriberStr={prescriberStr}
            setAttendedStr={setAttendedStr}
            setPrescriberStr={setPrescriberStr}
          />
        </div>
        {getValues('tipo_ficha') !== 'simple'
          ? (
            <Card
              style={{ width: '100%', padding: 0 }}
              tabList={tabListNoTitle}
              activeTabKey={tabState}
              onTabChange={(key) => {
                onTabChange(key);
              }}
              bordered={false}
              className="cardTabs"
            >
              {contentList[tabState]}
            </Card>
          )
          : <></>
        }
        {watch
          ? <></>
          : (
            <div className="footer_new">
              <div />
              <div className="flexRow">
                <Button className="buttonEye" onClick={() => setCancelModalState(true)}>
                  {intl.formatMessage({ id: 'pacientes.new_client.cancel' })}
                </Button>
                <Button
                  className="buttonEye"
                  type="primary"
                  style={{ marginLeft: '8px' }}
                  onClick={handleSubmit(onSubmit, () => setDoScroll(true))}
                  loading={guardandoOptometria}
                >
                  {intl.formatMessage({ id: 'pacientes.eye_chart.save_optometry' })}
                </Button>
              </div>
            </div>
          )
        }
        {drawerAttended
        && (
        <UsuariosDrawer
          visible={drawerAttended}
          onClose={() => {
            setDrawerAttended(false);
            setDrawerPrescriber(false);
          }}
          width={breakPoint.isTablet ? 386 : 522}
          pagination
          fetchData={searchData => dispatch(getUsuarios(searchData))}
          usuarios={usuarios}
          total={totalUsuarios}
          onSeleccionado={(user: any) => {
            setValue('atendido_por_id', user.id);
            setDrawerAttended(false);
            setAttendedStr(user.nombreCompleto);
          }}
        />
        )
        }
        {drawerPrescriber
        && (
        <UsuariosDrawer
          title="Prescriptores"
          visible={drawerPrescriber}
          onClose={() => {
            setDrawerAttended(false);
            setDrawerPrescriber(false);
          }}
          width={breakPoint.isTablet ? 386 : 522}
          pagination
          fetchData={searchData => dispatch(getPrescriptores(searchData))}
          usuarios={prescriptores}
          total={totalPrescriptores}
          onSeleccionado={(user: any) => {
            setValue('prescriptor_id', user.id);
            setDrawerPrescriber(false);
            setPrescriberStr(user.nombreCompleto);
          }}
        />
        )
        }
      </form>
    </>
  );
  return (
    <>
      <Page
        style={{ minWidth: '400px' }}
        tituloTraduccionId={pacienteSelected ? pacienteSelected.nombre_completo : `Ficha (${pacienteId})`}
        navigationItems={[
          {
            node: <Text children="" upperCase={false} lowerCase={false} translationId="navegacion.home" />,
            link: '',
          },
          {
            node: <Text children="" upperCase={false} lowerCase={false} translationId="navegacion.pacientes" />,
            link: '/pacientes/buscar',
          },
          {
            node: <Text upperCase={false} lowerCase={false} translationId={null}>{pacienteSelected ? pacienteSelected.nombre_completo : `Ficha (${pacienteId})`}</Text>,
            link: `/pacientes/file/${pacienteId}`,
          },
        ]}
        hasStickyActionsHeader={watch}
        loading={!pacienteSelected || optometriaSagaLoading}
      >
        <div className="patient patient-eyeChart">
          {pacienteSelected ? eyeChart : <LoadingWorkspaceSkeleton mt={0} hidePageTitle />}
          <CancelModal
            visible={cancelModalState}
            onClose={() => setCancelModalState(false)}
            goBackOnContinue
            onContinue={() => (!watch && !create ? history.push(cancelPath) : null)}
          />
        </div>
      </Page>
    </>
  );
}

export default injectIntl(EyeChart);
